import { DateTime } from "luxon"
import { ExtendedDynamicConfigKey, InputField, SelectValue } from "./formTypes"

export function applyFieldFallback(
    acc: Partial<Record<ExtendedDynamicConfigKey, any>>,
    inputField: InputField,
    key: ExtendedDynamicConfigKey,
    selectValues?: SelectValue[],
): void {
    const isBooleanField =
        inputField.type === "checkbox" || inputField.type === "toogle" || inputField.data === "boolean"

    if (inputField.predefined?.value !== undefined) {
        acc[key] = isBooleanField ? toPredefinedBoolean(inputField.predefined.value) : inputField.predefined.value
    } else if (inputField.data === "text") {
        acc[key] = ""
    } else if (inputField.type === "number") {
        acc[key] = undefined
    } else if (isBooleanField) {
        acc[key] = false
    } else if (inputField.type === "dateTimePicker") {
        acc[key] = DateTime.now()
    } else if (inputField.type === "select" && selectValues) {
        const prefilled = selectValues.find((o) => o.isPrefilled)?.value
        acc[key] = prefilled ?? null
    }
}

// Config may express a boolean predefined value as a real JSON boolean, as "true"/"false", or as 1/0.
function toPredefinedBoolean(value: string | number | boolean): boolean {
    if (typeof value === "boolean") return value
    if (typeof value === "string") return value.trim().toLowerCase() === "true"
    return value === 1
}
